/**
 * VCA Cache Configuration
 *
 * Shared React Query cache settings for VCA components.
 * VCA data changes infrequently (scraper runs daily/weekly),
 * so we use aggressive caching to improve perceived performance.
 */

// Vendors list - rarely changes, cache aggressively
export const VENDORS_QUERY_OPTIONS = {
  staleTime: 30 * 60 * 1000,      // Fresh for 30 min
  gcTime: 2 * 60 * 60 * 1000,     // Keep 2 hours
  refetchOnWindowFocus: false,
  retry: 1,
};

// Snapshot KPIs - updates with scraper, cache moderately
export const SNAPSHOT_QUERY_OPTIONS = {
  staleTime: 15 * 60 * 1000,      // Fresh for 15 min
  gcTime: 60 * 60 * 1000,         // Keep 1 hour
  refetchOnWindowFocus: false,
  retry: 1,
};

// Heatmap data - large payload, cache aggressively
export const HEATMAP_QUERY_OPTIONS = {
  staleTime: 15 * 60 * 1000,      // Fresh for 15 min
  gcTime: 60 * 60 * 1000,         // Keep 1 hour
  refetchOnWindowFocus: false,
  retry: 1,
};

// Displacement/renewals - updates with scraper
export const OPPORTUNITIES_QUERY_OPTIONS = {
  staleTime: 15 * 60 * 1000,      // Fresh for 15 min
  gcTime: 60 * 60 * 1000,         // Keep 1 hour
  refetchOnWindowFocus: false,
  retry: 1,
};

// Plan cards - user-specific, cache briefly
export const PLAN_QUERY_OPTIONS = {
  staleTime: 2 * 60 * 1000,       // Fresh for 2 min
  gcTime: 30 * 60 * 1000,         // Keep 30 min
  refetchOnWindowFocus: true,     // Refetch when returning to tab
  retry: 1,
};

// Win rates - computed from outcomes, cache moderately
export const WIN_RATES_QUERY_OPTIONS = {
  staleTime: 30 * 60 * 1000,      // Fresh for 30 min
  gcTime: 60 * 60 * 1000,         // Keep 1 hour
  refetchOnWindowFocus: false,
  retry: 1,
};

// Portfolio analysis - admin feature, cache moderately
export const PORTFOLIO_QUERY_OPTIONS = {
  staleTime: 15 * 60 * 1000,      // Fresh for 15 min
  gcTime: 60 * 60 * 1000,         // Keep 1 hour
  refetchOnWindowFocus: false,
  retry: 1,
};

// AI briefs - expensive to generate, cache aggressively
export const AI_BRIEF_QUERY_OPTIONS = {
  staleTime: 60 * 60 * 1000,      // Fresh for 1 hour
  gcTime: 4 * 60 * 60 * 1000,     // Keep 4 hours
  refetchOnWindowFocus: false,
  retry: 0,                        // Don't retry AI calls
};
